import { post } from '@api/request';

export async function search(
  { conferenceService },
  authenticationToken,
  { page = 1, pageSize = 500, sorting, payload },
) {
  let url = `${conferenceService}/conference/waitingroom/checkin/search`;
  let addSorting = false;
  if (sorting && Object.keys(sorting).length) {
    const sortingParam = `sortField=${sorting.field}&sortDirection=${sorting.direction}`;
    url = `${url}?${sortingParam}`;
    addSorting = true;
  }
  const pagingParam = `page=${page}&pageSize=${pageSize}`;
  url = `${url}${addSorting ? '&' : '?'}${pagingParam}`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}
